// @flow

import * as React from "react"
import Icon from "./icon"
import {connect} from "react-redux"
import {differenceInDays, isPast, isToday, format} from "date-fns"
import {withTranslation} from "react-i18next"
import ClassNames from "classnames"

import type {Dispatch, PlanningItem} from "../types"

type Props = {
  planningItem: PlanningItem,
  +dispatch: Dispatch,
  +readOnly: boolean,
  +showMadam: boolean,
  t: any,
  handleMarkAsDone: (PlanningItem) => void,
  handleEdit: (PlanningItem) => void,
}

type State = {}

class PlanningListItem extends React.Component<Props, State> {
  generateDescription() {
    const {planningItem, showMadam} = this.props
    if (showMadam) {
      return this.familyName() + ", " + format(planningItem.date, "HH.mm u")
    }
    if (planningItem.description.length) {
      return (
        <span dangerouslySetInnerHTML={{__html: planningItem.description}} />
      )
    }

    if (planningItem.key) {
      const {t} = this.props
      return t(`dashboard.planning.keys.${planningItem.key}`)
    }

    return ""
  }

  familyName() {
    const {planningItem} = this.props
    const {baby} = planningItem
    return baby ? baby.family.users.map((u) => u.firstname).join(" & ") : ""
  }

  render() {
    const {planningItem, handleMarkAsDone, handleEdit, readOnly, showMadam} =
      this.props
    const classNames = ClassNames("planning-list-item", {
      "is-past": isPast(planningItem.date) && !isToday(planningItem.date),
      "is-almost-due": differenceInDays(planningItem.date, new Date()) < 2,
    })
    const {baby, babyId, date, isActionable} = planningItem
    const familyLink =
      baby && babyId && !showMadam ? (
        <a
          className="family"
          href={window.menageConfig.baseUrl + "/admin/babies/" + babyId}
        >
          {this.familyName()}
        </a>
      ) : (
        <span className="family">
          {baby ? `${baby.madam.firstname} ${baby.madam.lastname}` : ""}
        </span>
      )
    const actions = readOnly ? null : (
      <span className="actions">
        {isActionable && (
          <button onClick={() => handleMarkAsDone(planningItem)}>
            <Icon name="icon-check" />
          </button>
        )}
        <button onClick={() => handleEdit(planningItem)}>
          <Icon name="icon-edit" />
        </button>
      </span>
    )

    return (
      <li className={classNames}>
        <time className="date">{format(date, "DD/MM")}</time>
        <span className="info">
          <span className="descr">{this.generateDescription()}</span>
          {familyLink}
          {/* {planningItem.dueDate} */}
        </span>
        {actions}
      </li>
    )
  }
}

export default withTranslation()(connect()(PlanningListItem))
